import { render, staticRenderFns } from "./BuyboxInternationnalOffersRow.vue?vue&type=template&id=1e4e87fc&scoped=true"
import script from "./BuyboxInternationnalOffersRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuyboxInternationnalOffersRow.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BuyboxInternationnalOffersRow.vue?vue&type=style&index=0&id=1e4e87fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4e87fc",
  null
  
)

export default component.exports